//----------------------------------------------------
// Project js file
//----------------------------------------------------

// bootstrap import
// import "bootstrap"
import Loader from "./parts/Loader.js";
import Navigation from "./parts/Navigation.js";
import Smooth from "./parts/Smooth.js";
import Accordion from "./parts/Accordion.js";
import MouseStalker from "./parts/MouseStalker.js";
import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";
import { Luminous, LuminousGallery } from "luminous-lightbox";
import "luminous-lightbox/dist/luminous-basic.min.css";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { SplitText } from "gsap/SplitText";

// スムーススクロール実装
//----------------------------------------------------
gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);

// ----------------------------------------------------
// ナビゲーション(ハンバーガーメニューの動作)
// ----------------------------------------------------
const siteNavigation = document.getElementById("site_navigation");
if (siteNavigation) {
  const navigation = new Navigation({
    humIdName: "hum_toggle",
    navIdName: "site_navigation",
  });
}

// ----------------------------------------------------
// ローダー
// ----------------------------------------------------
const loader = new Loader({
  endFn: async () => {
    console.log("load end");
    await recruitHero();
    await recruitFn();
  },
});

// ----------------------------------------------------
// 内部リンク
// ----------------------------------------------------
const smooth = new Smooth({
  linkTarget: '.nav_link a[href*="#"]',
  breakPoint: 1024, // px
  pcWaitTime: 0, // ms
  spWaitTime: 250, // ms
  exceptionId: ["exceptionId"], // 例外用のID
  exceptionFn: (id) => {
    // 例外処理
  },
});

// ----------------------------------------------------
// メインビジュアル　スライダー
// ----------------------------------------------------
const slideContainer = document.querySelector(".mainVisual_slide-container");
const slideItems = document.querySelectorAll(
  ".mainVisual_slide-container .swiper-slide"
);
if (slideContainer && slideItems.length > 1) {
  const slide = new Swiper(slideContainer, {
    initialSlide: 0,
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 0,
    loop: true,
    speed: 600,
    autoplay: {
      delay: 6000,
      stopOnLastSlide: false,
      disableOnInteraction: false,
      reverseDirection: false,
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
  });
} else if (slideContainer && slideItems.length <= 1) {
  slideContainer.classList.add("no_slide");
}

// ----------------------------------------------------
// チラシの拡大表示
// ----------------------------------------------------
const flyerWrapper = document.querySelector(".pageFlyer_wrapper");
if (flyerWrapper) {
  const options = {
    namespace: null,
    sourceAttribute: "href",
    caption: null,
    openTrigger: "click",
    closeTrigger: "click",
    closeWithEscape: true,
    closeOnScroll: false,
    showCloseButton: false,
    appendToNode: document.body,
    appendToSelector: null,
    onOpen: null,
    onClose: null,
    includeImgixJSClass: false,
    injectBaseStyles: true,
  };

  const flyerElm = document.querySelectorAll(`.luminous`);
  if (flyerElm.length) {
    flyerElm.forEach((elm) => {
      new Luminous(elm, options);
    });
  }
}

// ----------------------------------------------------
// リクルートページ　アニメーション
// ----------------------------------------------------
const recruitSection = document.querySelector(".pageRecruit_section");

// ヒーローアニメーション
// ----------------------------------------------------
async function recruitHero() {
  if (recruitSection) {
    // 画像のアニメーション
    const heroElm = document.querySelectorAll(".slideIn_mask-hero");
    const stagger = 78; // ms
    const shuffledElm = shuffleArray(heroElm);
    shuffledElm.forEach((elm, i) => {
      const time = i * stagger;
      setTimeout(() => {
        elm.classList.add("play");
      }, time);
    });

    // リンクボタンアニメーション
    const topLinkBtns = document.querySelectorAll(".pageRecruit_mv-link");
    gsap.to(topLinkBtns, {
      x: 0,
      autoAlpha: 1,
      duration: 0.8,
      delay: 0.5,
      ease: "expo.out",
      stagger: 0.25,
    });
  }
}

// 要素のシャッフル用関数
const shuffleArray = (array) => {
  const cloneArray = [...array];

  for (let i = cloneArray.length - 1; i >= 0; i--) {
    let rand = Math.floor(Math.random() * (i + 1));
    // 配列の要素の順番を入れ替える
    let tmpStorage = cloneArray[i];
    cloneArray[i] = cloneArray[rand];
    cloneArray[rand] = tmpStorage;
  }

  return cloneArray;
};

// スクロールアニメーション
// ----------------------------------------------------
async function recruitFn() {
  if (recruitSection) {
    if (scroller) scroller.kill();
    // 横からのスライドインするマスク [ slideIn_mask ]
    const slideInMaskElm = document.querySelectorAll(".slideIn_mask");
    slideInMaskElm.forEach((elm) => {
      ScrollTrigger.create({
        trigger: elm,
        start: "top 80%",
        toggleActions: "play none none none",
        toggleClass: {
          targets: elm,
          className: "play",
        },
        once: true,
      });
    });

    // 下からフェイドイン [ fadeIn_bottom ]
    const fadeInBottomElm = document.querySelectorAll(".fadeIn_bottom");
    const fadeInElmSplit = new SplitText(fadeInBottomElm, {
      type: "lines",
    });
    fadeInElmSplit.lines.forEach((parentElm) => {
      gsap.from(parentElm, {
        y: 40,
        autoAlpha: 0,
        duration: 0.8,
        ease: "expo.out",
        scrollTrigger: {
          trigger: parentElm,
          start: "top 80%",
          toggleActions: "play none none none",
        },
      });
    });

    // 最後のリンクボタン
    const recruitUnderBtns = document.querySelectorAll(
      ".pageRecruitEntry_link"
    );
    gsap.from(recruitUnderBtns, {
      y: 50,
      autoAlpha: 0,
      duration: 0.6,
      ease: "expo.out",
      stagger: 0.15,
      scrollTrigger: {
        trigger: ".pageRecruitEntry_wrapper",
        start: "top 80%",
        toggleActions: "play none none none",
      },
    });

    // コンセプトテキストのアニメーション
    const conceptSplitText = new SplitText("#recruit_concept", {
      type: "chars, lines",
    });
    conceptSplitText.lines.forEach((parentElm) => {
      gsap.from(parentElm.children, {
        autoAlpha: 0,
        duration: 0.8,
        ease: "expo.out",
        stagger: 0.045,
        scrollTrigger: {
          trigger: parentElm,
          start: "top 80%",
          toggleActions: "play none none none",
        },
      });
    });
  }
}

// ----------------------------------------------------
// アコーディオンメニュー
// ----------------------------------------------------
// // header
// const navAccordionList = gsap.utils.toArray('.sp_nav-li-ac')
// if (navAccordionList.length) {
//   const navAcordion = new Accordion(navAccordionList, {
//     // toggleBtnClass: ,
//     // itemClass: ,
//     firstDisplay: false,
//     onlyDisplay: false,
//     onChange: (elm, value, i) => {
//       const btn = gsap.utils.toArray('.sp_nav-acBtn', elm)
//       if (value) {
//         btn.forEach((elm) => {
//           elm.classList.add('active')
//         })
//       } else {
//         btn.forEach((elm) => {
//           elm.classList.remove('active')
//         })
//       }
//     }
//   })
// }

// ----------------------------------------------------
// マウスストーカー
// ----------------------------------------------------
// const mouseStalker = new MouseStalker({
//   stalkerClassName: "mouse_stalker",
//   hoverClass: "mouse_stalker-link",
//   scrub: 0.1,
// });

// ----------------------------------------------------
// スムーススクロール
// ----------------------------------------------------
let scroller;
// document.addEventListener("DOMContentLoaded", () => {
//   setTimeout(() => {
//     let smoothFlag = false;
//     function createSmooth() {
//       scroller = ScrollSmoother.create({
//         smooth: 0.6,
//         effects: true,
//         smoothTouch: 0.1,
//       });
//       smoothFlag = true;
//     }
//     if (window.innerWidth >= 768) {
//       createSmooth();
//     }
//     window.addEventListener("resize", () => {
//       if (
//         !smoothFlag &&
//         window.innerWidth >= 768 &&
//         location.pathname !== "/"
//       ) {
//         location.reload();
//       } else if (
//         smoothFlag &&
//         window.innerWidth < 768 &&
//         location.pathname !== "/"
//       ) {
//         location.reload();
//       }
//     });
//   }, 250);
// });
